import { CartOperationlModels, DeadpoolV2OperationalModel } from '~types/index'

const formatOperationalModelCart = (
  operationalModel: DeadpoolV2OperationalModel
): CartOperationlModels => {
  if (operationalModel === 'PICK_AND_COLLECT') {
    return 'PICK_UP'
  }
  return operationalModel
}

export default formatOperationalModelCart
